import { cn, Div } from '@scatterlab/zeta-core';
import {
  ComponentPropsWithoutRef,
  ComponentRef,
  createElement,
  ElementType,
  memo,
  RefAttributes,
} from 'react';

import { SymbolWhite } from '../logo';

export type SymbolTagProps<Component extends ElementType = typeof Div> =
  ComponentPropsWithoutRef<Component> &
    RefAttributes<ComponentRef<Component>> & {
      component?: Component;
      label: string;
    };

const SymbolTag = <Component extends ElementType = typeof Div>({
  component,
  label,
  className,
  ...props
}: SymbolTagProps<Component>) =>
  createElement(
    component ?? Div,
    {
      title: label,
      ...props,
      className: cn(
        'body12 flex flex-row items-center justify-center gap-[3px] rounded-md bg-black py-[1px] pl-[5px] pr-1',
        className,
      ),
    },
    <SymbolWhite className="h-[12.21px] w-[8.47px]" />,
    label,
  );

export default memo(SymbolTag) as typeof SymbolTag;
